// extracted by mini-css-extract-plugin
export default {"graph":"graph___MsgB8dJ","size":"size___MsgB8dJ","num":"num___MsgB8dJ","unit":"unit___MsgB8dJ"};